module.exports = "/_next/static/images/fff2bae974235faf6cbc700049059e35-vigilado-superfn.png.webp";